import { Link } from "react-router-dom"

function MenuItem(props) {
    return (
        <li className="mb-3">
            <Link to={props.url} className="text-decoration-none">
                <img className="me-2 menu-icon" src={props.image} />
                <span className={`${props.active ? 'fw-bold fst-italic' : ''} text-dark`}>{props.value}</span>
            </Link>
        </li>
    )
}

export default MenuItem